import type { Component } from "solid-js";
import { mergeProps, Show } from "solid-js";

type SeparatorLineProps = {
  class?: string;
  orientation?: "horizontal" | "vertical";
};
const SeparatorLine: Component<SeparatorLineProps> = (rawProps) => {
  const props = mergeProps({ orientation: "horizontal" }, rawProps);

  return (
    <Show
      when={props.orientation === "horizontal"}
      fallback={<div class={`border-l border-subtle ${props.class ?? ""}`} role="presentation" />}
    >
      <hr class={`border-t border-subtle ${props.class ?? ""}`} role="presentation" />
    </Show>
  );
};

export default SeparatorLine;
